function initSwiperSliders() {
  document.querySelectorAll('.mf_fd-wrapper.mySwiper').forEach((el) => {
    // Destroy existing swiper if still attached
    if (el.swiper) {
      el.swiper.destroy(true, true);
      // console.log("Destroyed existing swiper for re-init");
    }

    // console.log("Initializing swiper...");
    el.swiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 30,
      loop: true,
      allowTouchMove: false,
      speed: 5000,
      autoplay: {
        delay: 10,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      freeMode: false,
      breakpoints: {
        0:   { spaceBetween: 20 },
        550: { spaceBetween: 30 },
        1024:{ spaceBetween: 50 },
        1200:{ spaceBetween: 80 },
      },
      on: {
        init() {
          // console.log("Swiper initialized ✅");
        },
        autoplayStart() {
          // console.log("Autoplay started ▶️");
        },
        autoplayStop() {
          // console.log("Autoplay stopped ⏸️");
        }
      }
    });
  });
}

// Run listeners
document.addEventListener("DOMContentLoaded", initSwiperSliders);
document.addEventListener("shopify:section:load", initSwiperSliders);
window.addEventListener("load", () => setTimeout(initSwiperSliders, 1000));